/* eslint-disable */

import router from 'router';
import store from '../store';

const auth = {
  isLoginIn() {
    return !!localStorage.getItem('access_token');
  },
  checkLoginOverTime() {
    const twoHours = 60 * 60 * 2;
    const nowTime = Math.round(new Date().getTime() / 1000);
    const loginInTime = Math.round((+localStorage.getItem('expire_time') / 1000) + twoHours); // 1

    const loginStatus = nowTime > loginInTime ? (
      localStorage.removeItem('access_token'),
      store.commit('userService/user_login_out'),
      loginInTime !== twoHours ? alert('系統已登出') : ''
    ) : '';

    return loginStatus;
  },
};

router.beforeEach((to, from, next) => {
  
  auth.checkLoginOverTime();

  if (to.matched.some(record => record.meta.requiresAuth)) {
    
    if (!auth.isLoginIn()) {
      next({
        path: '/',
      });
    } else {
      next();
    }
    
  } else {

    /**
     * 假如處於登入情況下，使用者直接打網址，就讓使用者回到首頁
     */ 
    if (to.path === '/login' && auth.loggedIn()) {
      next({ path: '/' });
    }
    next(); 
  }
});



// WEBPACK FOOTER //
// ./src/router/auth.js